import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { PartnerResponse } from './models/partner-response.model';

@Injectable()
export class PartnersService {
	private readonly endpoint: string = `${environment.apiUrl}/partner`;

	constructor(private readonly http: HttpClient) {}

	getMany(): Observable<PartnerResponse[]> {
		return this.http.get<PartnerResponse[]>(this.endpoint);
	}
}
